import gql from 'graphql-tag';

export const shortFileFragmentQuery = `
  fragment ShortFileFragment on File {
    _id
    name
    description
    interactionIcon
    path
    type
    isFolder
  }
`;

export const fileFragmentQuery = `
  fragment FileFragment on File {
    _id
    name
    description
    interactionIcon
    type
    size
    creator
    isFolder
    createdAt
    updatedAt
    data {
      course
      isPublicAccess
      isNotHandout
      folder
      isLink
      parentFile
      isShared
    }
    path
  }
`;

export const shortFileFragment = gql`
    ${shortFileFragmentQuery}
`;

const fileFragment = gql`
    ${fileFragmentQuery}
`;

export default fileFragment;
